export const trialBanner = {
  title:
    '{daysLeft, plural, =0 {Your free trial ends today} one {{daysLeft} day left in your free trial} other {{daysLeft} days left in your free trial}}',
  body: 'Choose a plan so your children keep full access.',
  choosePlan: 'Choose a plan',
  dismiss: 'Dismiss',
  notifEndsOn: 'Ends {date}. Tap to choose a plan.',
  notifEndsToday: 'Ends today.',
} as const;
